import Access from './access'
import AccessOverview from './overview'

module.exports = {
  Access,
  AccessOverview
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/access/index.js